import React from 'react'
import { render as ReactRender, hydrate } from 'react-dom'
import p from './pass'

// config
import { config } from './Config/ConfigLoader'

const __DEV__ = DEV

import createStore from './store/createStore'
import AppContainer from './Containers/AppContainer'

const basenameElement = document.getElementById('basename')
let basename = '/'
if (basenameElement) {
  basename = basenameElement.value
//  basenameElement.parentNode.removeChild(basenameElement)
}

const tokenElement = document.getElementById('token')
const token = tokenElement.value
// tokenElement.parentNode.removeChild(tokenElement)

const subProductNameElement = document.getElementById('subProductName')
let subProductName = 'default'
if (subProductNameElement && subProductNameElement.value) {
  subProductName = subProductNameElement.value
}

const affiliateElement = document.getElementById('affiliate')
const affiliate = affiliateElement ? affiliateElement.value : ''

// ========================================================
// Store Instantiation
// ========================================================
const initialState = window.__PRELOADED_STATE__ || {}
const isPreloadedState = !!window.__PRELOADED_STATE__
delete window.__PRELOADED_STATE__
const store = createStore(initialState)

// ========================================================
// Render Setup
// ========================================================
const MOUNT_NODE = document.getElementById('app')

let render = () => {
  if (MOUNT_NODE.hasChildNodes()) {
    hydrate(
      <AppContainer
        affiliate={affiliate}
        basename={basename}
        isPreloadedState={isPreloadedState}
        p={p.charAt(0)}
        store={store}
        subProductName={subProductName}
        token={token}
      />,
      MOUNT_NODE
    )
  } else {
    ReactRender(
      <AppContainer
        affiliate={affiliate}
        basename={basename}
        isPreloadedState={isPreloadedState}
        p={p.charAt(0)}
        store={store}
        subProductName={subProductName}
        token={token}
      />,
      MOUNT_NODE
    )
  }
}

// ========================================================
// Developer Tools Setup
// ========================================================
if (__DEV__) {
  if (window.devToolsExtension) {
    // window.devToolsExtension.open()
  }
}

// ========================================================
// Go!
// ========================================================
render()
